/**
 * legacy-train-redirect.tsx — Link cũ của màn "Dạy AI": `/ai/train/:botId` → `/ai/nhan-vien/:botId`,
 * `/ai/train/:botId/handoff` → mục Chuyển người, `/ai/train/:botId/analytics` → trang Phân tích. Giữ ?query.
 */
import { Navigate, useLocation, useParams } from 'react-router-dom'

export function LegacyTrainRedirect({ to }: { to: 'detail' | 'handoff' | 'analytics' }) {
  const { botId } = useParams<{ botId: string }>()
  const { search } = useLocation()
  const base = `/ai/nhan-vien/${botId ?? ''}`
  const path = to === 'analytics' ? `${base}/phan-tich${search}` : `${base}${search}${to === 'handoff' ? '#chuyen-nguoi' : ''}`
  return <Navigate to={path} replace />
}
